import React, { ReactNode, createContext, useContext, useEffect } from 'react';

import kfuseRumSDK from 'kf-browser-sdk';

import { getKfuseConfig } from './constants';
import { KfuseContextType } from './types';
import {
  getBrowserAgent,
  setKfuseMetrics,
  setNoticeError,
  setupGlobalErrorHandlers,
  trackEvent,
} from './utils';

// Single Kfuse monitoring context
const KfuseContext = createContext<KfuseContextType>({
  setNoticeError,
  trackEvent,
  setKfuseMetrics,
  getBrowserAgent,
});

type KfuseProviderProps = {
  children: ReactNode;
};

export const KfuseProvider: React.FC<KfuseProviderProps> = ({ children }) => {
  useEffect(() => {
    // Initialize Kfuse at the beginning with dynamic configuration
    kfuseRumSDK.init(getKfuseConfig());

    // Set up global error handlers regardless of route
    const cleanupErrorHandlers = setupGlobalErrorHandlers();
    return cleanupErrorHandlers;
  }, []);

  return (
    <KfuseContext.Provider
      value={{
        setNoticeError,
        trackEvent,
        setKfuseMetrics,
        getBrowserAgent,
      }}
    >
      {children}
    </KfuseContext.Provider>
  );
};

export const useKfuse = (): KfuseContextType => useContext(KfuseContext);
